<template>
    <input type="text" :class="aspect.formFieldClass" v-model="fieldValue" :placeholder="placeholder" @input="emitChange()" />
</template>

<script>
    import axios from 'axios';
    export default {
        name: 'form-element-cf',
        props: {
            value:{ type:String },
            translations: {type: Object},
            aspect: {type: Object, default: function(){ return {}; }},
            placeholder: null,
            formFields: {type: Object, default: function(){ return {}; }},
            refreshIndex: {type: Number, default: 0}
        },
        data(){
            return {
                fieldValue: this.value,
                time: 1
            }
        },
        watch: {
            refreshIndex: {
                deep: true,
                handler(){
                    this.fieldValue = this.value
                }
            }
        },
        methods: {
            emitChange(){
                this.$emit('input', this.fieldValue);
            },
            evaluateValidationCondition(condition){
                if(condition.type == "simple-cf"){
                    if(this.value && this.value.length == 16){
                        let pattern = /^[a-zA-Z]{6}[0-9]{2}[a-zA-Z][0-9]{2}[a-zA-Z][0-9]{3}[a-zA-Z]$/;
                        if(this.value.search(pattern) == -1){
                            return this.translations.cfWarning;
                        }
                    }else{
                        if(this.value && this.value.length == 11){
                            var pi = this.value+"";
                            if( pi == '' )  return '';
                            if( ! /^[0-9]{11}$/.test(pi) )
                                return this.translations.vatWarning;
                            var s = 0;
                            for( i = 0; i <= 9; i += 2 )
                                s += pi.charCodeAt(i) - '0'.charCodeAt(0);
                            for(var i = 1; i <= 9; i += 2 ){
                                var c = 2*( pi.charCodeAt(i) - '0'.charCodeAt(0) );
                                if( c > 9 )  c = c - 9;
                                s += c;
                            }
                            var atteso = ( 10 - s%10 )%10;
                            return ( atteso != pi.charCodeAt(10) - '0'.charCodeAt(0) )?this.translations.vatWarning:null;
                        }
                        return this.translations.cfWarning;
                    }
                }
                if(condition.type == "complex-cf"){
                    if(this.value && this.value.length == 16){
                        var birthdate = new Date(this.formFields[condition.birthdate].value);
                        var fiscalCode = new FiscalCode(
                            condition.url, this.value,
                            this.formFields[condition.firstNameField].value,
                            this.formFields[condition.lastNameField].value,
                            birthdate.getFullYear(),
                            birthdate.getMonth()+1,
                            birthdate.getDate(),
                            this.formFields[condition.birthlocation].value.city,
                            this.formFields[condition.birthlocation].value.country,
                            this.formFields[condition.genderField].value ==  condition.genderMaleValue);
                        var isValid = fiscalCode.isValid();
                        if(!isValid){
                            return this.translations.cfWarning;
                        }
                    }else{
                        return this.translations.cfWarning;
                    }
                }
                return null;
            }
        }
    }

    class FiscalCode {

        constructor(api_url, fiscalCode, firstName, lastName, yearOfBirth, monthOfBirth, dayOfBirth, cityOfBirth, countryOfBirth, isMale){
            this.api_url = api_url;
            this.fiscalCode = fiscalCode.toUpperCase().trim();
            this.firstName = firstName.toUpperCase().replace(/\s/g, "").replace(/'/g, '');
            this.lastName = lastName.toUpperCase().replace(/\s/g, "").replace(/'/g, '');
            this.yearOfBirth = yearOfBirth+"";
            this.monthOfBirth = monthOfBirth+"";
            this.dayOfBirth = dayOfBirth+"";
            this.countryOfBirth = countryOfBirth;
            this.cityOfBirth = cityOfBirth;
            this.isMale = isMale;
        }
        digitReplace(char){
            var charReturn = "";
            char = char+"";
            if(char == "L"){ charReturn = "0"; }
            if(char == "M"){ charReturn = "1"; }
            if(char == "N"){ charReturn = "2"; }
            if(char == "P"){ charReturn = "3"; }
            if(char == "Q"){ charReturn = "4"; }
            if(char == "R"){ charReturn = "5"; }
            if(char == "S"){ charReturn = "6"; }
            if(char == "T"){ charReturn = "7"; }
            if(char == "U"){ charReturn = "8"; }
            if(char == "V"){ charReturn = "9"; }
            return charReturn;
        }

        normalize(str){
            var digitChanged = false;
            if(isNaN(str.charAt(6))){ digitChanged = true; str = str.substring(0, 6) + this.digitReplace(str.charAt(6)) + str.substring(7, 16); }
            if(isNaN(str.charAt(7))){ digitChanged = true; str = str.substring(0, 7) + this.digitReplace(str.charAt(7)) + str.substring(8, 16); }
            if(isNaN(str.charAt(9))){ digitChanged = true; str = str.substring(0, 9) + this.digitReplace(str.charAt(9)) + str.substring(10, 16); }
            if(isNaN(str.charAt(10))){ digitChanged = true; str = str.substring(0, 10) + this.digitReplace(str.charAt(10)) + str.substring(11, 16); }
            if(isNaN(str.charAt(12))){ digitChanged = true; str = str.substring(0, 12) + this.digitReplace(str.charAt(12)) + str.substring(13, 16); }
            if(isNaN(str.charAt(13))){ digitChanged = true; str = str.substring(0, 13) + this.digitReplace(str.charAt(13)) + str.substring(14, 16); }
            if(isNaN(str.charAt(14))){ digitChanged = true; str = str.substring(0, 14) + this.digitReplace(str.charAt(14)) + str.substring(15, 16); }
            if(digitChanged){
                return str.substring(0, 15) + this.getCheckChar(str);
            }else{
                return str;
            }
        }

        isConsonant(letter){
            if(letter == "A" || letter == "E" || letter == "I" || letter == "O" || letter == "U"){ return false; }
            else{ return true; }
        }

        lastNameCheck(str){
            var consonants = [];
            var vocals = [];
            var checkString = "";
            for(var i=0; i<this.lastName.length; i++){
                if(this.isConsonant(this.lastName.charAt(i))){
                    consonants.push(this.lastName.charAt(i));
                }else{
                    vocals.push(this.lastName.charAt(i));
                }
            }
            if(consonants.length >= 3){ checkString = consonants[0]+consonants[1]+consonants[2]; }
            if(consonants.length == 2 && vocals.length >= 1){ checkString = consonants[0]+consonants[1]+vocals[0]; }
            if(consonants.length == 1 && vocals.length >= 2){ checkString = consonants[0]+vocals[0]+vocals[1]; }
            if(consonants.length == 1 && vocals.length == 1){ checkString = consonants[0]+vocals[0]+"X"; }
            if(consonants.length == 0 && vocals.length == 2){ checkString = vocals[0]+vocals[1]+"X"; }
            for(var i=0; i<checkString.length; i++){
                if(!isNaN(checkString.charAt(i))){
                    return false;
                }
            }
            return checkString==str;
        }

        firstNameCheck(str){
            var consonants = [];
            var vocals = [];
            var checkString = "";
            for(var i=0; i<this.firstName.length; i++){
                if(this.isConsonant(this.firstName.charAt(i))){
                    consonants.push(this.firstName.charAt(i));
                }else{
                    vocals.push(this.firstName.charAt(i));
                }
            }
            if(consonants.length >= 4){ checkString = consonants[0]+consonants[2]+consonants[3]; }
            if(consonants.length == 3){ checkString = consonants[0]+consonants[1]+consonants[2]; }
            if(consonants.length == 2 && vocals.length >= 1){ checkString = consonants[0]+consonants[1]+vocals[0]; }
            if(consonants.length == 1 && vocals.length >= 2){ checkString = consonants[0]+vocals[0]+vocals[1]; }
            if(consonants.length == 1 && vocals.length == 1){ checkString = consonants[0]+vocals[0]+"X"; }
            if(consonants.length == 0 && vocals.length == 2){ checkString = vocals[0]+vocals[1]+"X"; }
            for(var i=0; i<checkString.length; i++){
                if(!isNaN(checkString.charAt(i))){
                    return false;
                }
            }
            return checkString==str;
        }

        birthYearCheck(str){
            if(isNaN(this.yearOfBirth)){ return false; }
            var checkString = (this.yearOfBirth+"").substring(this.yearOfBirth.length-2, this.yearOfBirth);
            return checkString==str;
        }

        birthMonthCheck(str){
            var checkString = "";
            var monthToNumber = parseInt(this.monthOfBirth);
            if(isNaN(monthToNumber) && monthToNumber < 1 && monthToNumber > 12){ return false; }
            if(monthToNumber == 1){ checkString = "A"; }
            if(monthToNumber == 2){ checkString = "B"; }
            if(monthToNumber == 3){ checkString = "C"; }
            if(monthToNumber == 4){ checkString = "D"; }
            if(monthToNumber == 5){ checkString = "E"; }
            if(monthToNumber == 6){ checkString = "H"; }
            if(monthToNumber == 7){ checkString = "L"; }
            if(monthToNumber == 8){ checkString = "M"; }
            if(monthToNumber == 9){ checkString = "P"; }
            if(monthToNumber == 10){ checkString = "R"; }
            if(monthToNumber == 11){ checkString = "S"; }
            if(monthToNumber == 12){ checkString = "T"; }
            return checkString==str;
        }

        birthDayCheck(str){
            var checkString = "";
            var dayToNumber = parseInt(this.dayOfBirth);
            if(isNaN(dayToNumber) || dayToNumber < 1 || dayToNumber > 31){ return false; }
            if(this.isMale == false){ dayToNumber += 40; }
            if(dayToNumber < 10){ checkString = "0"+dayToNumber; }
            else{ checkString = dayToNumber+""; }
            return checkString==str;
        }

        async birthCityCheck(str){
            var result = await axios.post(this.api_url+str+'&cityId='+this.cityOfBirth+'&countryId='+this.countryOfBirth).then((r)=>{
                if(r.data){
                    if(this.countryOfBirth == 100) {
                        return r.data == this.cityOfBirth;
                    }else {
                        return r.data == this.countryOfBirth;
                    }
                }
            });
            return result;
        }

        getCheckChar(str){
            var checksum = 0;
            for(var i=0; i<str.length-1; i++){
                var char = str.charAt(i)+"";
                var checkNumber = -1;
                if( (i+1) % 2 == 1){
                    if(char == "A" || char == "0"){ checkNumber = 1; }
                    if(char == "B" || char == "1"){ checkNumber = 0; }
                    if(char == "C" || char == "2"){ checkNumber = 5; }
                    if(char == "D" || char == "3"){ checkNumber = 7; }
                    if(char == "E" || char == "4"){ checkNumber = 9; }
                    if(char == "F" || char == "5"){ checkNumber = 13; }
                    if(char == "G" || char == "6"){ checkNumber = 15; }
                    if(char == "H" || char == "7"){ checkNumber = 17; }
                    if(char == "I" || char == "8"){ checkNumber = 19; }
                    if(char == "J" || char == "9"){ checkNumber = 21; }
                    if(char == "K"){ checkNumber = 2; }
                    if(char == "L"){ checkNumber = 4; }
                    if(char == "M"){ checkNumber = 18; }
                    if(char == "N"){ checkNumber = 20; }
                    if(char == "O"){ checkNumber = 11; }
                    if(char == "P"){ checkNumber = 3; }
                    if(char == "Q"){ checkNumber = 6; }
                    if(char == "R"){ checkNumber = 8; }
                    if(char == "S"){ checkNumber = 12; }
                    if(char == "T"){ checkNumber = 14; }
                    if(char == "U"){ checkNumber = 16; }
                    if(char == "V"){ checkNumber = 10; }
                    if(char == "W"){ checkNumber = 22; }
                    if(char == "X"){ checkNumber = 25; }
                    if(char == "Y"){ checkNumber = 24; }
                    if(char == "Z"){ checkNumber = 23; }
                }else{
                    if(char == "A" || char == "0"){ checkNumber = 0; }
                    if(char == "B" || char == "1"){ checkNumber = 1; }
                    if(char == "C" || char == "2"){ checkNumber = 2; }
                    if(char == "D" || char == "3"){ checkNumber = 3; }
                    if(char == "E" || char == "4"){ checkNumber = 4; }
                    if(char == "F" || char == "5"){ checkNumber = 5; }
                    if(char == "G" || char == "6"){ checkNumber = 6; }
                    if(char == "H" || char == "7"){ checkNumber = 7; }
                    if(char == "I" || char == "8"){ checkNumber = 8; }
                    if(char == "J" || char == "9"){ checkNumber = 9; }
                    if(char == "K"){ checkNumber = 10; }
                    if(char == "L"){ checkNumber = 11; }
                    if(char == "M"){ checkNumber = 12; }
                    if(char == "N"){ checkNumber = 13; }
                    if(char == "O"){ checkNumber = 14; }
                    if(char == "P"){ checkNumber = 15; }
                    if(char == "Q"){ checkNumber = 16; }
                    if(char == "R"){ checkNumber = 17; }
                    if(char == "S"){ checkNumber = 18; }
                    if(char == "T"){ checkNumber = 19; }
                    if(char == "U"){ checkNumber = 20; }
                    if(char == "V"){ checkNumber = 21; }
                    if(char == "W"){ checkNumber = 22; }
                    if(char == "X"){ checkNumber = 23; }
                    if(char == "Y"){ checkNumber = 24; }
                    if(char == "Z"){ checkNumber = 25; }
                }
                checksum += checkNumber;
            }
            checksum %= 26;
            var controlChar = "";
            if(checksum == 0){ controlChar = "A"; }
            if(checksum == 1){ controlChar = "B"; }
            if(checksum == 2){ controlChar = "C"; }
            if(checksum == 3){ controlChar = "D"; }
            if(checksum == 4){ controlChar = "E"; }
            if(checksum == 5){ controlChar = "F"; }
            if(checksum == 6){ controlChar = "G"; }
            if(checksum == 7){ controlChar = "H"; }
            if(checksum == 8){ controlChar = "I"; }
            if(checksum == 9){ controlChar = "J"; }
            if(checksum == 10){ controlChar = "K"; }
            if(checksum == 11){ controlChar = "L"; }
            if(checksum == 12){ controlChar = "M"; }
            if(checksum == 13){ controlChar = "N"; }
            if(checksum == 14){ controlChar = "O"; }
            if(checksum == 15){ controlChar = "P"; }
            if(checksum == 16){ controlChar = "Q"; }
            if(checksum == 17){ controlChar = "R"; }
            if(checksum == 18){ controlChar = "S"; }
            if(checksum == 19){ controlChar = "T"; }
            if(checksum == 20){ controlChar = "U"; }
            if(checksum == 21){ controlChar = "V"; }
            if(checksum == 22){ controlChar = "W"; }
            if(checksum == 23){ controlChar = "X"; }
            if(checksum == 24){ controlChar = "Y"; }
            if(checksum == 25){ controlChar = "Z"; }
            return controlChar;
        }

        controlCharCheck(str){
            return str==this.getCheckChar(this.fiscalCode);
        }

        isValid(){
            if(this.fiscalCode.length != 16){ return false; }
            if(!this.controlCharCheck(this.fiscalCode.substring(15, 16))){ return false; }
            this.fiscalCode = this.normalize(this.fiscalCode);
            if(!this.lastNameCheck(this.fiscalCode.substring(0, 3))){ return false; }
            if(!this.firstNameCheck(this.fiscalCode.substring(3, 6))){ return false; }
            if(!this.birthYearCheck(this.fiscalCode.substring(6, 8))){ return false; }
            if(!this.birthMonthCheck(this.fiscalCode.substring(8, 9))){ return false; }
            if(!this.birthDayCheck(this.fiscalCode.substring(9, 11))){ return false; }
            var check = this.birthCityCheck(this.fiscalCode.substring(11, 15));
            if(!check){ return false; }
            return true;
        }
    }
</script>
